ScoreTrekBattle.Tournament.Series = ScoreTrekBattle.Tournament.Series || {};

ScoreTrekBattle.Tournament.Series.Edit = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        validation: {
            'title': {
                mandatory: true,
            }
        }
    };

    function resetStatus() {
        STATUS = {
            active: false,
            loadedSeries: null,
            allSeries: null,
            allTournaments: null,
            tournamentOptions: [],
            selectedTournamentIds: [],
            $view: null,
            form: null
        };
    }
    resetStatus();

    function onViewRenderCreate() {
        STATUS.loadedSeries = null;
        STATUS.allTournaments = null;
        STATUS.allSeries = null;
        STATUS.tournamentOptions = [];
        STATUS.selectedTournamentIds = [];

        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Series.Edit.onViewRenderCreate', true);
            loadAll().then(() => {
                onViewRender().then($view => {
                    resolve($view);
                });
            }).catch(error => {
                handleError(error);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Series.Edit.onViewRenderCreate', false);
            });
        });
    }

    function onViewRenderEdit(seriesId) {
        STATUS.loadedSeries = null;
        STATUS.allTournaments = null;
        STATUS.allSeries = null;
        STATUS.tournamentOptions = [];
        STATUS.selectedTournamentIds = [];

        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Series.Edit.onViewRenderEdit', true);
            Api.request('/battle/tournament/series/load', {id: seriesId}).then(result => {
                STATUS.loadedSeries = result.series;
                STATUS.selectedTournamentIds = STATUS.loadedSeries.tournamentIds;
                loadAll().then(() => {
                    onViewRender().then($view => {
                        resolve($view);
                    });
                }).catch(error => {
                    handleError(error);
                    reject();
                });
            }).catch(error => {
                handleError(error);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Series.Edit.onViewRenderEdit', false);
            });
        });
    }

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu('/tournament/create');
            var buttonText;
            buttonText = STATUS.loadedSeries ? __i18n('button/saveSeries') : __i18n('button/addSeries');
            ScoreTrekBattle.Template.render('tournament/series/edit', {
                introTitle: __i18n(`tournament/series/form/${STATUS.loadedSeries ? 'edit' : 'create'}/title`, {button: buttonText}),
                introText: __i18n(`tournament/series/form/${STATUS.loadedSeries ? 'edit' : 'create'}/text`, {button: buttonText}),
                buttonText: buttonText
            }).then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                try {
                    STATUS.form = view.forms.editSeries;
                } catch(e) {
                    console.warn(e);
                    STATUS.form = null;
                }
                setSeriesName();
                renderData();
                setTimeout(() => {
                    STATUS.$view.find('input, select, textarea').trigger('change');

                    updateTournamentSelect();
                    addEventListeners();
                    resolve(STATUS.$view);
                }, 0);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            if (STATUS.loadedSeries) {
                // TODO render data?
            }
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function onCheckAccess() {
        return ScoreTrekBattle.Session.isBattleManager();
    }

    function handleError(error) {
        if (error && error.message) {
            chmDialog.error(error);
        }
    }

    function loadAll() {
        return new Promise(function(resolve, reject) {
            Promise.all([
                Api.request('/battle/tournament/all').then(result => {
                    STATUS.allTournaments = result.list;
                }),
                Api.request('/battle/tournament/series/all').then(result => {
                    STATUS.allSeries = result.list;
                })
            ]).then(() => {
                var optgroups, optgroupsMap;

                optgroups = [
                    $('<optgroup>').attr('label', `-- ${__i18n('tournament/series/none')} --`)
                ];

                optgroupsMap = {
                    '': 0
                };

                STATUS.allSeries.forEach(series => {
                    optgroupsMap[series.id] = optgroups.length;
                    optgroups.push($('<optgroup>').attr('label', series.title));
                });

                STATUS.allTournaments.forEach(tournament => {
                    (optgroups[optgroupsMap[tournament.seriesId || '']] || optgroups[0]).append(
                        $('<option>').attr({
                            value: tournament.id,
                            'data-text': tournament.title
                        }
                    ).append(
                        ScoreTrekBattle.Tournament.renderSelectItem(tournament))
                    );
                });

                optgroups = optgroups.filter(optgroup => {
                    return (optgroup.children().length > 0);
                });

                STATUS.tournamentOptions = optgroups;

                resolve();
            }).catch(reject);
        });
    }

    function renderData() {
        var promises;

        if (!STATUS.form || !STATUS.loadedSeries) {
            return;
        }

        promises = [];
        STATUS.loadedSeries.tournamentIds.forEach(tournamentId => {
            promises.push(ScoreTrekBattle.Template.render('tournament/series/tournamentItem', {
                tournament: STATUS.allTournaments.find(tournament => {
                    return tournament.id === tournamentId;
                })
            }));
        });

        Promise.all(promises).then(items => {
            var $list;

            $list = STATUS.$view.find('[data-id="tournamentsEditor"]');

            items.forEach(item => {
                $list.append(item.$view);
            });
        });

        STATUS.form.fields.forEach(field => {
            if (STATUS.loadedSeries.hasOwnProperty(field.name)) {
                field.set(STATUS.loadedSeries[field.name]);
            }
        });
    }

    function updateTournamentSelect() {
        var $select;

        if (!STATUS.$view) {
            return;
        }

        $select = STATUS.$view.find('[data-id="addTournament"]');

        $select.empty().append(
            $('<option>').attr('value', '').text('')
        ).append(
            STATUS.tournamentOptions
        );

        $select.find(`option`).prop('disabled', false);
        STATUS.selectedTournamentIds.forEach(tournamentId => {
            $select.find(`option[value="${tournamentId}"]`).prop('disabled', true);
        });
    }

    function addEventListeners() {
        STATUS.$view.find('[data-id="addTournament"]').on('change', function() {
            var tournamentId, newTournament;

            tournamentId = this.value;
            this.value = '';


            newTournament = STATUS.allTournaments.find(tournament => {
                return (tournament.id === tournamentId);
            });

            if (!newTournament) {
                return;
            }

            STATUS.selectedTournamentIds.push(tournamentId);

            updateTournamentSelect();


            ScoreTrekBattle.Template.render('tournament/series/tournamentItem', {
                tournament: newTournament
            }).then(item => {
                var $editor, $next;

                $editor = STATUS.$view.find('[data-id="tournamentsEditor"]');

                $editor.children().each(function() {
                    if (parseInt(this.dataset.tournamentTimestamp, 10) > newTournament.dateTimeTournamentTimestamp) {
                        $next = $(this);
                        return false;
                    }
                });

                item.$view.hide();

                if ($next) {
                    $next.before(item.$view);
                } else {
                    $editor.append(item.$view);
                }
                
                item.$view.slideDown();
            });
        });
    }

    function generateSeriesName(noHTML) {
        return noHTML ? __i18n('tournament/series/new') : `<i>${__i18n('tournament/series/new')}</i>`;
    }

    function setSeriesName(seriesName, isDefaultName) {
        var $seriesName;

        if (!seriesName) {
            seriesName = STATUS.loadedSeries ? STATUS.loadedSeries.title : generateSeriesName();
            isDefaultName = !STATUS.loadedSeries;
        }

        $seriesName = STATUS.$view.find('[data-id="seriesName"]');

        $seriesName.attr('data-is-default', isDefaultName ? 'yes' : 'no');

        $seriesName[isDefaultName ? 'html' : 'text'](seriesName);
    }

    function getSeriesName() {
        return STATUS.$view.find('[data-id="seriesName"]').text();
    }

    function inputSeriesName() {
        return new Promise(function(resolve, reject) {
            var $seriesName;
            $seriesName = STATUS.$view.find('[data-id="seriesName"]');

            if ($seriesName.attr('data-is-default') === 'yes') {
                editSeriesName(getSeriesName()).then(seriesName => {
                    setSeriesName(seriesName, true);
                    resolve(seriesName);
                }).catch(reject);
            } else {
                resolve(getSeriesName());
            }

        });
    }

    function getTournamentIds() {
        return STATUS.selectedTournamentIds;
    }

    function saveSeries(seriesId) {
        inputSeriesName().then(seriesName => {
            var seriesData;

            seriesData = {
                title: seriesName,
                description: STATUS.form ? STATUS.form.controls.description.get() : '',
                hasRanking: STATUS.form ? STATUS.form.controls.hasRanking.get() : true,
                rankingFormula: STATUS.form ? STATUS.form.controls.rankingFormula.get() : '',
                tournamentIds: getTournamentIds()
            };

            if (seriesId) {
                seriesData.id = seriesId;
            }

            validateSeries(seriesData).then(data => {
                storeSeries(data, true).then(series => {
                    if (series) {
                        ScoreTrekBattle.View.goto(`/series/plan/${series.id}`);
                    }
                }).catch(ignore => {});
            }).catch(errors => {
                STATUS.form.showErrors(errors);
            });
        }).catch(ignore => {});
    }

    function validateSeries(data) {
        return new Promise(function(resolve, reject) {
            var errors;

            if (!STATUS.active) {
                console.warn('action.tournamentSeries.save triggered while not active.');
                reject([]);
                return;
            }

            errors = [];
            Object.keys(CONFIG.validation).forEach(fieldName => {
                var validate, isMandatory;

                validate = CONFIG.validation[fieldName];

                isMandatory = validate.mandatory;

                if (isMandatory && !data[fieldName]) {
                    errors.push({
                        field: fieldName,
                        message: __i18n('error/field/mandatory')
                    });
                }
            });

            if (errors.length === 0) {
                resolve(data);
            } else {
                reject(errors);
            }
        });
    }

    function storeSeries(seriesData, showConfirmation) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Series.Edit.saveSeries', true);
            Api.request(`/battle/tournament/series/${seriesData.hasOwnProperty('id') ? 'update' : 'create'}`, {
                series: seriesData
            }).then(result => {
                if (result && result.done) {
                    if (showConfirmation !== false) {
                        chmDialog.success(__i18n(`tournament/series/${seriesData.hasOwnProperty('id') ? 'update' : 'create'}/done`), null, __i18n('button/ok')).then(() => {
                            resolve(result.series);
                        });
                    } else {
                        resolve(result.series);
                    }
                } else {
                    chmDialog.error(`tournament/series/${seriesData.hasOwnProperty('id') ? 'update' : 'create'}/failed`);
                    reject();
                }
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                AnimationHandler.scrollToTop(false, STATUS.$view);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Series.Edit.saveSeries', false);
            });
        });
    }

    function editSeriesName(currentSeriesName) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n('dialog/tournamentSeries/name/title'),
                prompt: __i18n('dialog/tournamentSeries/name/prompt'),
                value: currentSeriesName
            }).then(seriesName => {
                if (!seriesName) {
                    reject();
                    return;
                }
                resolve(seriesName);
            }).catch(reject);
        });
    }

    function deleteSeries(seriesId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Series.Edit.deleteSeries', true);
            Api.request('/battle/tournament/series/delete', {id: seriesId}).then(result => {
                resolve();
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Series.Edit.deleteSeries', false);
            });
        });
    }

    _this = {
        add: function() {
            return new Promise(function(resolve, reject) {
                editSeriesName(generateSeriesName(true)).then(seriesName => {
                    storeSeries({
                        title: seriesName
                    }, false).then(series => {
                        if (series) {
                            resolve(series);
                        } else {
                            reject();
                        }
                    }).catch(reject);
                }).catch(reject);
            });
        }
    };

    ScoreTrekBattle.View.register('/series/create', onViewRenderCreate, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess);
    ScoreTrekBattle.View.register('/series/edit', onViewRenderEdit, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess);

    ScoreTrekBattle.Event.on('action.tournamentSeries.save', function() {
        saveSeries(STATUS.loadedSeries ? STATUS.loadedSeries.id : null);
    });

    ScoreTrekBattle.Event.on('action.series.editName', function() {
        var $series;
        $series = $(this).closest('[data-series-id]');
        editSeriesName($series.find('[data-id="series.title"]').text()).then(seriesName => {
            storeSeries({
                id: $series.attr('data-series-id'),
                title: seriesName
            }).then(series => {
                if (series) {
                    ['title', 'modified'].forEach(fieldName => {
                        $series.find(`[data-id="series.${fieldName}"]`).text(series[fieldName]);
                    });
                }
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.series.rename', function() {
        if (!STATUS.active) {
            return;
        }

        editSeriesName(getSeriesName()).then(seriesName => {
            if (!STATUS.loadedSeries) {
                setSeriesName(seriesName);
                return;
            }

            storeSeries({
                id: STATUS.loadedSeries.id,
                title: seriesName
            }, false).then(series => {
                if (series) {
                    setSeriesName(series.title);
                }
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.series.delete', function() {
        var $series, seriesId, seriesName;
        $series = $(this).closest('[data-series-id]');
        seriesId = $series.attr('data-series-id');
        seriesName = $series.find('[data-id="series.title"]').text();
        chmDialog.confirm(__i18n('dialog/confirm/deleteSeries/text', {colorClass: 'color-blue', reference: seriesName}, true), {
            title: __i18n('dialog/confirm/deleteSeries/title'),
            icon: '<i class="text-red"><i class="fa-solid fa-trash-can"></i></i>',
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            deleteSeries(seriesId).then(() => {
                $series.slideUp(() => {
                    $series.remove();
                });
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.series.tournament.remove', function() {
        var $tournament, tournamentId;
        $tournament = $(this).closest('[data-tournament-id]');
        tournamentId = $tournament.attr('data-tournament-id');

        STATUS.selectedTournamentIds = STATUS.selectedTournamentIds.filter(id => {
            return (id !== tournamentId);
        });

        updateTournamentSelect();

        $tournament.slideUp(() => {
            $tournament.remove();
        });
    });

    return _this;
})();